var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagStripes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -18,
    y2: 30,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -14,
    y2: 34,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -10,
    y2: 38,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -6,
    y2: 42,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    y2: 48,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 4,
    y2: 52,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8,
    y2: 56,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 12,
    y2: 60,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 18,
    y2: 66,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 22,
    y2: 70,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 26,
    y2: 74,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 30,
    y2: 78,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 36,
    y2: 84,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 40,
    y2: 88,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 44,
    y2: 92,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 48,
    y2: 96,
    x2: 96,
    stroke: "#6D450E",
    strokeLinecap: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagStripes);
export default __webpack_public_path__ + "static/media/DiagStripes.5d5d0f30d1be23cf97bab8d0adb7010a.svg";
export { ForwardRef as ReactComponent };